"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var iconv = require("iconv-lite");
var validation_error_1 = require("./validation-error");
var form_definition_1 = require("../form-definition");
var utilities_1 = require("../utilities");
var form_constants_1 = require("../form-definition/form-constants");
var form_elements_1 = require("../form-definition/form-elements");
var isValidEmail = utilities_1.emailUtilities.isValidEmail;
var getWordCount = utilities_1.textUtilities.getWordCount;
function invalidEmailError(id, element, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(id, displayLabel, section, errorNum, "Please enter a valid email address.", validation_error_1.errorTypes.inline);
}
function elementError(element, message, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, message);
}
function requiredResponseError(element, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "Element requires a response");
}
;
/**
 * returns a generic incomplete error
 * @param element the element that the error pertains to
 * @param section the level of the error (form-element)
 * @param errorNum the error number, used to distinguish this form other errors
 * @param parentElement the group element that contains the element, if one exists
 */
function incompleteResponseError(element, section, errorNum, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "This is incomplete, please provide a value.");
}
;
function unexpectedTypeError(element, section, errorNum, actualType, expectedType, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "invalid response type [" + actualType + "], it should be an " + expectedType);
}
;
function decimalLimitExceededError(element, section, errorNum, decimalLimit, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, "invalid response. Number of decimal places cannot exceed " + decimalLimit.toString(), validation_error_1.errorTypes.inline);
}
;
function numberOutOfBoundsError(element, section, errorNum, minVal, maxVal, currentVal, numberType, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    var numberWording = numberType === form_definition_1.numericElementTypes.MONEY ? 'an amount' : numberType === form_definition_1.numericElementTypes.PERCENTAGE ? 'a percentage' : 'a number';
    var dollars = numberType === form_definition_1.numericElementTypes.MONEY ? '$' : '';
    var percent = numberType === form_definition_1.numericElementTypes.PERCENTAGE ? '%' : '';
    var warn;
    if (minVal !== null && minVal !== undefined && typeof currentVal === 'number' && currentVal < minVal) {
        if (maxVal !== null && maxVal !== undefined)
            warn = 'You can enter ' + numberWording + ' between ' + dollars + minVal.toString() + percent + ' and ' + dollars + maxVal.toString() + percent + ".";
        else
            warn = 'You can enter ' + numberWording + ' greater than or equal to ' + dollars + minVal.toString() + percent + ".";
    }
    else if (maxVal !== null && maxVal !== undefined && typeof currentVal === 'number' && currentVal > maxVal) {
        if (minVal !== null && minVal !== undefined)
            warn = 'You can enter ' + numberWording + ' between ' + dollars + minVal.toString() + percent + ' and ' + dollars + maxVal.toString() + percent + ".";
        else
            warn = 'You can enter ' + numberWording + ' less than or equal to ' + dollars + maxVal.toString() + percent + ".";
    }
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, warn, validation_error_1.errorTypes.inline);
}
;
function dateOutOfBoundsError(element, section, errorNum, minVal, maxVal, parentElement) {
    var displayLabel = element.label || (parentElement && parentElement.label);
    var minDisplay = utilities_1.dateUtilities.getUserFriendlyFormat(minVal);
    var maxDisplay = utilities_1.dateUtilities.getUserFriendlyFormat(maxVal);
    var warn;
    if (maxVal && minVal) {
        warn = 'Please enter a date between ' + minDisplay + ' and ' + maxDisplay + '.';
    }
    else if (minVal) {
        warn = 'Please enter a date on or after ' + minDisplay + '.';
    }
    else if (maxVal) {
        warn = 'Please enter a date on or before ' + maxDisplay + '.';
    }
    return validation_error_1.validationError(element.id, displayLabel, section, errorNum, warn, validation_error_1.errorTypes.inline);
}
function incompleteSelectionError(element, subSection, section, errorNum) {
    return validation_error_1.sectionedValidationError(element.id, element.label, subSection, section, errorNum, "incomplete value", validation_error_1.errorTypes.inline);
}
;
function invalidSelectionError(element, subSection, section, errorNum, expectedSelection) {
    return validation_error_1.sectionedValidationError(element.id, element.label, subSection, section, errorNum, "unexpected value, expecting value in range " + expectedSelection, validation_error_1.errorTypes.inline);
}
;
/**
 * Runs validation on the entire form state
 * @param state the form state to validate
 * @returns returns a modified form state with an updated validation result
 */
function runValidation(state, country) {
    var passedValidation = true;
    var errors = [];
    var modifiedState = state.set('validationResult', new form_definition_1.ValidationResult({}));
    modifiedState = validateFormElements(modifiedState, country);
    modifiedState = validateForm(modifiedState);
    return modifiedState;
}
exports.runValidation = runValidation;
;
/**
 * Perform validation on all the form elements
 * @param {FormState} state the FormState containing the form and value information
 * @returns modified form state
 */
function validateFormElements(state, country) {
    var _a = state || new form_definition_1.FormState({}), form = _a.form, validationResult = _a.validationResult;
    var passedValidation = true;
    var errors = [];
    if (!!form) {
        var elements = form.elements;
        if (elements) {
            elements.forEach(function (element) {
                var elementValidation = validateFormElement(country, state, element);
                passedValidation = elementValidation.passedValidation && passedValidation;
                errors.push.apply(errors, elementValidation.errors.toArray());
            }, this);
        }
    }
    return state.set('validationResult', new form_definition_1.ValidationResult({
        passedValidation: validationResult.passedValidation && passedValidation,
        errors: validationResult.errors.concat(errors).toList()
    }));
}
exports.validateFormElements = validateFormElements;
/**
 * Validate an individual form element
 * @param formState the form state
 * @param element the element being evaluated
 * @param parentElement the group element that contains the element being evaluated
 * @param requireCompletion if true, it will override whether or not completion is required for a group element
 * @returns validation errors
 */
function validateFormElement(country, formState, element, parentElement, requireCompletion) {
    var value = formState.value;
    var passedValidation = true;
    var errors = [];
    var elementValue = value && value.get(element.id);
    var response = form_definition_1.getValue(formState, element.id, country);
    if (element.disabled || element.hidden || !form_definition_1.elementStoresData(element.type) || element.readOnly) {
        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
    }
    var elementEmptyValue = form_definition_1.hasEmptyValue(element, response, formState);
    if (elementEmptyValue && element.type !== form_definition_1.elementTypes.group && element.isRequired) {
        passedValidation = false;
        errors.push(requiredResponseError(element, 'form-element', errors.length, parentElement));
    }
    if (!elementEmptyValue || element.type === form_definition_1.elementTypes.group) {
        var type = typeof (response);
        switch (element.type) {
            case form_definition_1.elementTypes.group: {
                var groupValidation = validateGroupValue(element, formState, requireCompletion, country, parentElement);
                passedValidation = groupValidation.passedValidation && passedValidation;
                errors.push.apply(errors, groupValidation.errors.toArray());
                break;
            }
            case form_definition_1.elementTypes.radio:
            case form_definition_1.elementTypes.select:
            case form_definition_1.elementTypes.checkbox:
            case form_definition_1.elementTypes.likert:
                if (!immutable_1.List.isList(response)) {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "List"));
                }
                break;
            case form_definition_1.elementTypes.text:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                if (element.maxCharLength && element.maxCharLength > 0 && iconv.encode(response, 'utf8').length > element.maxCharLength) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "Exceeded character limit", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
                break;
            case form_definition_1.elementTypes.textArea:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                var wordCount = getWordCount(response);
                if (element.wordLimit && element.wordLimit > 0 && wordCount > element.wordLimit) {
                    passedValidation = false;
                    var wordLimitErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "Exceeded word limit", validation_error_1.errorTypes.inline);
                    errors.push(wordLimitErr);
                }
                if (element.maxCharLength && element.maxCharLength > 0 && response.length > element.maxCharLength) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "Exceeded character limit", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
                break;
            case form_definition_1.elementTypes.gisCoordinates:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                break;
            case form_definition_1.elementTypes.date:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                }
                // check if valid date string
                var isValid = utilities_1.dateUtilities.isValidDate(response, country);
                if (!isValid) {
                    passedValidation = false;
                    errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Enter a valid date', validation_error_1.errorTypes.inline));
                }
                else {
                    // check date limits
                    if (!utilities_1.dateUtilities.isDateInRange(response, element.minDate, element.maxDate, element.earliestAllowed, element.latestAllowed)) {
                        passedValidation = false;
                        errors.push(dateOutOfBoundsError(element, 'form-element', errors.length, element.minDate, element.maxDate));
                    }
                }
                break;
            case form_definition_1.elementTypes.number:
                var responseAsNumber = utilities_1.numberUtilities.stringToNumber(response);
                if (response === null || response === undefined || response === "")
                    break;
                if (responseAsNumber === null) {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "number"));
                }
                else {
                    if (element.decLimit !== null && utilities_1.numberUtilities.decPlaces(responseAsNumber) > element.decLimit) {
                        passedValidation = false;
                        errors.push(decimalLimitExceededError(element, 'form-element', errors.length, element.decLimit));
                    }
                    if (element.minVal !== null && responseAsNumber < element.minVal) {
                        passedValidation = false;
                        errors.push(numberOutOfBoundsError(element, 'form-element', errors.length, element.minVal, element.maxVal, responseAsNumber, element.numericNumberType));
                    }
                    if (element.maxVal !== null && responseAsNumber > element.maxVal) {
                        passedValidation = false;
                        errors.push(numberOutOfBoundsError(element, 'form-element', errors.length, element.minVal, element.maxVal, responseAsNumber, element.numericNumberType));
                    }
                }
                break;
            case form_definition_1.elementTypes.phone:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                }
                // check if valid phone number string
                var phoneRegEx = /^\d{10}$/;
                if (!phoneRegEx.test(response)) {
                    passedValidation = false;
                    errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a 10 digit number.', validation_error_1.errorTypes.inline));
                }
                break;
            case form_definition_1.elementTypes.email:
                if (type !== 'string') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                }
                // check if valid email string
                if (!isValidEmail(response)) {
                    passedValidation = false;
                    errors.push(invalidEmailError(element.id, element, 'form-element', errors.length));
                }
                break;
            case form_definition_1.elementTypes.duration:
                if (type !== 'object') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "object"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                var hours = response.get('hours');
                var mins = response.get('minutes');
                if (element.isRequired && !hours && !mins) {
                    passedValidation = false;
                    errors.push(requiredResponseError(element, 'form-element', errors.length));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                if ((hours && typeof (hours) !== 'number') || (mins && typeof (mins) !== 'number')) {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "number"));
                }
                if (hours > 999 || hours < 0) {
                    passedValidation = false;
                    errors.push(validation_error_1.sectionedValidationError(element.id, element.label, 'hours', 'form-element', errors.length, 'Enter a value between 0 and 999', validation_error_1.errorTypes.inline));
                }
                if (element.useHours && (mins > 59 || mins < 0)) {
                    passedValidation = false;
                    errors.push(validation_error_1.sectionedValidationError(element.id, element.label, 'minutes', 'form-element', errors.length, 'Enter a value between 0 and 59', validation_error_1.errorTypes.inline));
                }
                else if (!element.useHours && (mins > 99999 || mins < 0)) {
                    passedValidation = false;
                    errors.push(validation_error_1.sectionedValidationError(element.id, element.label, 'minutes', 'form-element', errors.length, 'Enter a value between 0 and 99999', validation_error_1.errorTypes.inline));
                }
                break;
            case form_definition_1.elementTypes.nationalId:
                if (!elementEmptyValue) {
                    if (type !== 'string') {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    }
                    // check if valid id string (Canadian SIN or American SSN)
                    var nationalIdRegEx = /^\d{9}$/;
                    if (!nationalIdRegEx.test(response)) {
                        passedValidation = false;
                        errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a 9 digit number.', validation_error_1.errorTypes.inline));
                    }
                }
                break;
            case form_definition_1.elementTypes.postalCode:
                if (!elementEmptyValue) {
                    if (type !== 'string') {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
                    }
                    // check if valid, based on country's specific rule set
                    var postalCodeRegex = void 0;
                    switch (element.country) {
                        case form_definition_1.countryCodes.UnitedKingdom:
                            postalCodeRegex = /^([A-Za-z][A-Ha-hJ-Yj-y]?[0-9][A-Za-z0-9]? ?[0-9][A-Za-z]{2}|[Gg][Ii][Rr] ?0[Aa]{2})$/;
                            if (!postalCodeRegex.test(response)) {
                                passedValidation = false;
                                errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a valid UK Postal Code.', validation_error_1.errorTypes.inline));
                            }
                            break;
                        case form_definition_1.countryCodes.Canada:
                            // in the format A1A 1A1, where A is a letter and 1 is a digit. allowing the space to be present or absent
                            postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ ]?\d[A-Za-z]\d$/;
                            if (!postalCodeRegex.test(response)) {
                                passedValidation = false;
                                errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Please enter a valid six-character Postal Code.', validation_error_1.errorTypes.inline));
                            }
                            break;
                        case form_definition_1.countryCodes.UnitedStates:
                        default:
                            // default to U.S. style of 5 digits
                            postalCodeRegex = /^\d{5}$/;
                            if (!postalCodeRegex.test(response)) {
                                passedValidation = false;
                                errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'Zip Code must be five digits long.', validation_error_1.errorTypes.inline));
                            }
                            break;
                    }
                }
                break;
            case form_definition_1.elementTypes.specialText: {
                var specialTextValidation = validateSpecializedTextValue(element, response);
                passedValidation = specialTextValidation.passedValidation && passedValidation;
                errors.push.apply(errors, specialTextValidation.errors.toArray());
                break;
            }
            case form_definition_1.elementTypes.time: {
                if (!elementEmptyValue) {
                    var timeValidation = validateTimeValue(element, response);
                    passedValidation = timeValidation.passedValidation && passedValidation;
                    errors.push.apply(errors, timeValidation.errors.toArray());
                }
                break;
            }
            case form_definition_1.elementTypes.attachment:
                if (!elementValue) {
                    break;
                }
                var files = response.get('files');
                var numFiles = response.get('fileCount');
                if (element.isRequired && (!files || !numFiles || !files.size || files.size === 0)) {
                    passedValidation = false;
                    errors.push(requiredResponseError(element, 'form-element', errors.length));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                if (files !== null && files !== undefined && !!files.size && files.size > 0) {
                    var filesUploaded = response.get('completedUploads');
                    var isUploading = files.some(function (file) { return file.get('isUploading'); });
                    if (isUploading) {
                        passedValidation = false;
                        errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'The file has not finished uploading'));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                    else if (numFiles - filesUploaded !== 0 || numFiles !== files.size) {
                        passedValidation = false;
                        errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, 'There was an error uploading the selected files. Please try again.', validation_error_1.errorTypes.inline));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                    var imagesOnly = element.imageAttachment;
                    var maxUploadSize = element.uploadSize;
                    var maxTotalUploadSize = element.maxTotalUploadSize;
                    var totalUploadSize = 0;
                    var imgFilter = /^image\//;
                    var file, i;
                    for (i = 0; i < numFiles; i++) {
                        file = files.get(i);
                        if (maxUploadSize !== 0 && file.get('size') > maxUploadSize) {
                            passedValidation = false;
                            errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "A file exceeded the maximum upload size of " + utilities_1.numberUtilities.formatBytesForString(maxUploadSize) + ".", validation_error_1.errorTypes.inline));
                            return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                        }
                        if (imagesOnly === true && !imgFilter.test(file.get('contentType'))) {
                            passedValidation = false;
                            errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "You may only upload images.", validation_error_1.errorTypes.inline));
                            return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                        }
                        totalUploadSize += file.get('size');
                        if (totalUploadSize > maxTotalUploadSize) {
                            passedValidation = false;
                            errors.push(validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, (numFiles === 1 ? 'The file exceeds' : 'Combined, the files exceed') + " the maximum total upload size of " + utilities_1.numberUtilities.formatBytesForString(maxTotalUploadSize) + ".", validation_error_1.errorTypes.inline));
                            return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                        }
                    }
                }
                break;
            case form_definition_1.elementTypes.electronicSignature:
                if (type !== 'object') {
                    passedValidation = false;
                    errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "object"));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                //apricot stores sig data as a string in 'imageUrl' field
                if (element.mode === form_constants_1.electronicSignatureModes.APRICOT) {
                    var coord = response.get('imageUrl');
                    if (!!coord && typeof (coord) !== 'string') {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, typeof (coord), "string"));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                }
                //eto stores sig data as an array in 'etoCoords' field
                else if (element.mode === form_constants_1.electronicSignatureModes.ETO) {
                    var coord = response.get('etoCoords');
                    if (coord && !immutable_1.List.isList(coord)) {
                        passedValidation = false;
                        errors.push(unexpectedTypeError(element, 'form-element', errors.length, typeof (coord), "list"));
                        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                    }
                }
                else {
                    passedValidation = false;
                    errors.push(validation_error_1.validationError(element.id, element.label, null, errors.length, 'Invalid mode', validation_error_1.errorTypes.global));
                    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
                }
                break;
            default: break;
        }
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateFormElement = validateFormElement;
/**
 * Perform validation for form-wide requirements
 * @param {object} state the FormState containing the form and value information
 */
function validateForm(state) {
    var _a = state || new form_definition_1.FormState({}), form = _a.form, value = _a.value, validationResult = _a.validationResult, recaptchaValue = _a.recaptchaValue;
    var elements = form.elements;
    var passedValidation = true;
    var errors = [];
    if (!!form && form.includeRecaptcha && !recaptchaValue) {
        passedValidation = false;
        errors.push(validation_error_1.validationError('0', '', 'form-element', errors.length, 'The google reCAPTCHA at the bottom of the form must be completed to submit the form.', validation_error_1.errorTypes.global));
    }
    // Currently, only requirement across the form is maximum total attachment size limit
    if (elements && !!form.maxTotalAttachmentSize) {
        var formAttachmentsSize = 0;
        elements.forEach(function (element) {
            if (!!value) { // do not perform validation against a value if there is no value present
                var response = value.get(element.id);
                if (!element.disabled && !element.hidden && response !== undefined && response !== null && response !== "" &&
                    (!immutable_1.List.isList(response) || response.size > 0) && formAttachmentsSize <= form.maxTotalAttachmentSize) {
                    switch (element.type) {
                        case form_definition_1.elementTypes.attachment:
                            var files = response.get('files');
                            var numFiles = response.get('fileCount');
                            if (files !== null && files !== undefined && !!files.size && files.size > 0) {
                                var filesUploaded = response.get('completedUploads');
                                var isUploading = files.some(function (file) { return file.get('isUploading'); });
                                if (isUploading || (numFiles - filesUploaded !== 0 || numFiles !== files.size)) {
                                    return;
                                }
                                var file, i;
                                for (i = 0; i < numFiles; i++) {
                                    file = files.get(i);
                                    formAttachmentsSize += file.get('size');
                                    if (formAttachmentsSize > form.maxTotalAttachmentSize) {
                                        passedValidation = false;
                                        errors.push(validation_error_1.validationError('0', '', 'form-element', errors.length, "The combined files exceeded the maximum form upload size of " + utilities_1.numberUtilities.formatBytesForString(form.maxTotalAttachmentSize) + ".", validation_error_1.errorTypes.global));
                                        return;
                                    }
                                }
                            }
                            break;
                        default: break;
                    }
                }
            }
        }, this);
    }
    return state.set('validationResult', new form_definition_1.ValidationResult({
        passedValidation: validationResult.passedValidation && passedValidation,
        errors: validationResult.errors.concat(errors).toList()
    }));
}
exports.validateForm = validateForm;
/**
 * This function runs validation on a particular group element
 * This will evaluate all the subElements of the group, taking into account any modifications made by the group's properties
 * @param element group element definition
 * @param state the forms state
 * @param requireCompletion if true, this group will evaluate to not empty regardless of the value returned by hasEmptyValue
 * @returns a validation result, representing the validation of this group element
 */
function validateGroupValue(element, state, requireCompletion, country, parentElement) {
    if (requireCompletion === void 0) { requireCompletion = false; }
    var passedValidation = true;
    var errors = [];
    if (!element.hidden && !element.disabled && element.subElementsList) {
        var groupValue = form_definition_1.getValue(state, element.id);
        var emptyGroup = form_definition_1.hasEmptyValue(element, groupValue, state);
        var requiredDefinition = element.immutableRequiredDefinition || new form_elements_1.ImmutableBasicRequiredDefinition({});
        var completionRequired_1 = requireCompletion ? true : !emptyGroup && requiredDefinition.requireCompleteResponse;
        // Required validation for groups - handle different required definition types
        if (element.isRequired && element.subElementsList.size > 0) {
            if (requiredDefinition.type === form_constants_1.requireType.ANY) {
                // For ANY type: check if at least one enabled sub-element has a response
                var hasValidResponse = element.subElementsList.some(function (subElement) {
                    var subElementValue = form_definition_1.getValue(state, subElement.id);
                    var subElementEmpty = form_definition_1.hasEmptyValue(subElement, subElementValue, state);
                    return !subElementEmpty && !subElement.disabled && !subElement.hidden;
                });
                if (!hasValidResponse) {
                    passedValidation = false;
                    errors.push(elementError(element, "A response is required for at least one of these elements.", 'form-element', errors.length, parentElement));
                }
            }
            else {
                // For ALL/SOME types: use the existing empty group logic
                if (emptyGroup) {
                    // Check if any subElements are actually required based on the requiredDefinition
                    var hasRequiredSubElements = element.subElementsList.some(function (subElement) {
                        return form_definition_1.isSubElementRequiredByGroup(element, subElement);
                    });
                    if (hasRequiredSubElements) {
                        passedValidation = false;
                        errors.push(requiredResponseError(element, 'form-element', errors.length, parentElement));
                    }
                }
            }
        }
        // For MULTIPLE_CHOICE_OTHER groups, skip sub-element validation
        // The group itself handles validation of the combined mc + other value
        if (!utilities_1.elementTypeHelpers.isMcOtherGroup(element)) {
            element.subElementsList.forEach(function (subElement) {
                var isSubElementRequired = form_definition_1.isSubElementRequiredByGroup(element, subElement);
                var subElementValue = form_definition_1.getValue(state, subElement.id);
                var subElementEmpty = form_definition_1.hasEmptyValue(subElement, subElementValue, state);
                if (completionRequired_1 && !element.isRequired && subElement.type !== form_definition_1.elementTypes.group &&
                    isSubElementRequired && subElementEmpty &&
                    !subElement.hidden && !subElement.disabled) {
                    passedValidation = false;
                    errors.push(incompleteResponseError(subElement, 'form-element', errors.length, element));
                }
                var modifiedSubElement = form_definition_1.getModifiedSubElement(element, subElement);
                var elementValidation = validateFormElement(country, state, modifiedSubElement, element, completionRequired_1 && isSubElementRequired);
                passedValidation = elementValidation.passedValidation && passedValidation;
                errors.push.apply(errors, elementValidation.errors.toArray());
            }, this);
        }
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateGroupValue = validateGroupValue;
/**
 * This function runs validation on a particular time element, given the value
 * @param element time element definition
 * @param value value of the time element
 * @returns a validation result, representing the validation of this individual time element
 */
function validateTimeValue(element, value) {
    var passedValidation = true;
    var errors = [];
    var required = element.isRequired && !element.disabled && !element.hidden;
    var type = typeof (value);
    var expectedType = "object";
    if (type !== expectedType) {
        passedValidation = false;
        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, expectedType));
        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
    }
    var timeValue = value;
    var numHours = parseInt(timeValue.hour, 10);
    var numMins = parseInt(timeValue.minute, 10);
    if ((timeValue.hour && !timeValue.minute) || (!timeValue.hour && timeValue.minute)) {
        passedValidation = false;
        var subSection = timeValue.hour ? 'minute' : 'hour';
        errors.push(incompleteSelectionError(element, subSection, 'form-element', errors.length));
    }
    if (timeValue.minute && (isNaN(numMins) || numMins < 0 || numMins > 59)) {
        passedValidation = false;
        errors.push(invalidSelectionError(element, 'minute', 'form-element', errors.length, "[0-59]"));
    }
    if (element.isMilitaryTime) {
        if (timeValue.hour && (isNaN(numHours) || numHours < 0 || numHours > 23)) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'hour', 'form-element', errors.length, "[0-23]"));
        }
        if (timeValue.period) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'period', 'form-element', errors.length, "[\"\"]"));
        }
    }
    else {
        if (timeValue.hour && (isNaN(numHours) || numHours < 1 || numHours > 12)) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'hour', 'form-element', errors.length, "[1-12]"));
        }
        if (!timeValue.period || (timeValue.period && timeValue.period !== 'AM' && timeValue.period !== 'PM')) {
            passedValidation = false;
            errors.push(invalidSelectionError(element, 'period', 'form-element', errors.length, "[AM, PM]"));
        }
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateTimeValue = validateTimeValue;
/**
 * This function runs validation on a particular specialized text element, given the value.
 * It checks to see if the length requirements of the text are met, and that only valid characters are used.
 * @param element specialized text element definition
 * @param value value of the specialized text element
 * @returns a validation result, representing the validation of this individual specialized text element
 */
function validateSpecializedTextValue(element, value) {
    var passedValidation = true;
    var errors = [];
    var type = typeof (value);
    if (type !== 'string') {
        passedValidation = false;
        errors.push(unexpectedTypeError(element, 'form-element', errors.length, type, "string"));
        return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
    }
    var textResponse = value;
    // text length validation
    var isMinLimit = element.minCharLength !== undefined && element.minCharLength !== null;
    var isMaxLimit = element.maxCharLength !== undefined && element.maxCharLength !== null;
    if (isMinLimit && isMaxLimit && element.minCharLength === element.maxCharLength && textResponse.length !== element.minCharLength) {
        passedValidation = false;
        var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response must have exactly " + element.minCharLength + " characters.", validation_error_1.errorTypes.inline);
        errors.push(charLengthErr);
    }
    else if (isMinLimit && textResponse.length < element.minCharLength) {
        passedValidation = false;
        var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response must have at least " + element.minCharLength + " characters.", validation_error_1.errorTypes.inline);
        errors.push(charLengthErr);
    }
    else if (isMaxLimit && textResponse.length > element.maxCharLength) {
        passedValidation = false;
        var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response cannot have more than " + element.maxCharLength + " characters.", validation_error_1.errorTypes.inline);
        errors.push(charLengthErr);
    }
    // text content validation
    switch (element.textType) {
        case form_definition_1.specialTextTypes.NUMERIC:
            {
                var regex = RegExp('[^0-9]', 'g');
                if (regex.test(textResponse)) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response should only contain numbers.", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
            }
            break;
        case form_definition_1.specialTextTypes.ALPHA:
            {
                var regex = RegExp('[^A-Za-z]', 'g');
                if (regex.test(textResponse)) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response should only contain letters.", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
            }
            break;
        case form_definition_1.specialTextTypes.ALPHA_NUMERIC:
            {
                var regex = RegExp('[^A-Za-z0-9_]', 'g');
                if (regex.test(textResponse)) {
                    passedValidation = false;
                    var charLengthErr = validation_error_1.validationError(element.id, element.label, 'form-element', errors.length, "The response should only contain alpha numeric characters.", validation_error_1.errorTypes.inline);
                    errors.push(charLengthErr);
                }
            }
            break;
        case form_definition_1.specialTextTypes.ANY:
        default: break;
    }
    return new form_definition_1.ValidationResult({ passedValidation: passedValidation, errors: immutable_1.List(errors) });
}
exports.validateSpecializedTextValue = validateSpecializedTextValue;
//# sourceMappingURL=run-validation.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/validation/run-validation.js
// module id = 1165
// module chunks = 0